import { AntDesign } from "@expo/vector-icons";
import { observer } from "mobx-react";
import moment from "moment";
import React from "react";
import {
  ActivityIndicator,
  Dimensions,
  Image,
  SafeAreaView,
  ScrollView,
  StyleSheet,
  Text,
  View,
} from "react-native";
import { Button } from "react-native-elements";
import { RFValue } from "react-native-responsive-fontsize";
import { Row, Table } from "react-native-table-component";
import updatePoi from "../../networking/api/verification/updatePoi";
import { navigate } from "../../routes/Global";
import state from "../../store/Store";

const { height, width } = Dimensions.get("window");

const POI = observer(({ data, loading }) => {
  const { uid } = state;
  const tableHead = [
    "#",
    "Image",
    "Firebase Reference No.",
    "Full Name",
    "Address",
    "Signing Date",
    "View Document",
    "Approve Service Provider",
    "Reject Service Provider",
  ];

  const tableData = data?.map((record, index) => {
    let number = index + 1;
    const { image, firstName, lastName, address, createdAt, path, key } =
      record || {};
    const { ext, url } = path || {};
    const { line1, state, city, zipCode } = address || {};
    let location = [line1, state, city, zipCode]
      .filter((o) => Boolean(o))
      .join(", ");
    let signUpDate = moment.unix(createdAt).format("MM/DD/YYYY");

    return [
      number,
      image ? (
        <Image source={{ uri: image }} style={styles.image} />
      ) : (
        <View style={styles.image} />
      ),
      key,
      firstName + " " + lastName,
      location,
      signUpDate,
      <Button
        title="View"
        buttonStyle={styles.buttonStyle}
        titleStyle={styles.buttonTitle}
        onPress={() => navigate("viewpoidocument", { ext, url })}
      />,
      <Button
        title="Approve"
        // disabled={currentReq !== "ML DOCUMENT SUBMITTED"}
        buttonStyle={[styles.buttonStyle, { backgroundColor: "green" }]}
        titleStyle={styles.buttonTitle}
        onPress={async () => await updatePoi(key, "APPROVED", firstName)}
      />,
      <Button
        title="Reject"
        // disabled={currentReq !== "ML DOCUMENT SUBMITTED"}
        buttonStyle={[styles.buttonStyle, { backgroundColor: "red" }]}
        titleStyle={styles.buttonTitle}
        onPress={async () => await updatePoi(key, "REJECTED", firstName)}
      />,
    ];
  });
  return (
    <Table>
      <Row
        data={tableHead}
        style={styles.head}
        textStyle={styles.headerText}
        flexArr={tableHead.map((o, i) => (i === 0 ? 0.25 : i === 1 ? 0.5 : 1))}
      />
      <ScrollView
        nestedScrollEnabled={true}
        contentContainerStyle={styles.scrollView}
        bounces={false}
        showsVerticalScrollIndicator={false}
      >
        {loading ? (
          <ActivityIndicator animating size="large" />
        ) : (
          <SafeAreaView style={styles.view}>
            {tableData.length === 0 ? (
              <Text style={styles.notFound}>No records found</Text>
            ) : (
              <Table>
                {tableData?.map((rowData, index) => (
                  <View key={rowData + index.toString()}>
                    <Row
                      data={rowData}
                      style={styles.row}
                      textStyle={styles.text}
                      flexArr={tableHead.map((o, i) =>
                        i === 0 ? 0.25 : i === 1 ? 0.5 : 1
                      )}
                    />
                    <View style={styles.borderLine} />
                  </View>
                ))}
              </Table>
            )}
          </SafeAreaView>
        )}
      </ScrollView>
    </Table>
  );
});

export default POI;

const styles = StyleSheet.create({
  notFound: {
    fontFamily: "avenir-h",
    fontSize: RFValue(22),
    textAlign: "center",
    color: "gray",
  },
  rowView: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginHorizontal: 10,
  },
  buttonTitle: { fontSize: RFValue(9), fontFamily: "avenir" },
  buttonStyle: {
    width: width * 0.08,
    marginBottom: 2.5,
    paddingVertical: 5,
    borderRadius: 10,
    backgroundColor: "#2E3339",
  },
  borderLine: { borderBottomWidth: 0.5 },
  view: { marginBottom: height * 0.025 },
  tableStyle: { borderColor: "transparent" },
  scrollView: { flexGrow: 0 },
  imageStyle: {
    width: 35,
    height: 35,
    borderRadius: 35 / 2,
  },
  container: {
    flex: 1,
    padding: 16,
    marginBottom: 36,
    backgroundColor: "#fff",
  },
  head: { backgroundColor: "#ECECF4", flexGrow: 0 },
  text: { margin: 6, fontSize: RFValue(10), fontFamily: "avenir" },
  headerText: {
    margin: 6,
    fontSize: RFValue(10),
    fontFamily: "avenir",
  },
  row: { flexDirection: "row", backgroundColor: "white", marginTop: 10 },
  image: {
    width: 40,
    height: 40,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: "#d3d3d3",
    backgroundColor: "gray",
  },
  textStyle: { fontFamily: "avenir", fontSize: RFValue(10) },
});
